var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.876,
    height: 94.775,
    viewBox: "0 0 133.876 94.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3182.664 2090.904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-282.9-471-304.2h24.462l12.819,21.3-12.819,21.474H-471Z",
    transform: "translate(3707.674 -1786.204)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-282.9-471-304.2h24.462l12.819,21.3-12.819,21.474H-471Z",
    transform: "translate(3666.674 -1760.204)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-282.9-471-304.2h24.462l12.819,21.3-12.819,21.474H-471Z",
    transform: "translate(3707.674 -1735.204)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-282.9-471-304.2h24.462l12.819,21.3-12.819,21.474H-471Z",
    transform: "translate(3749.674 -1762.204)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan2);
export default __webpack_public_path__ + "static/media/plan-2.614596476b04e44aa342bcb99dc24dac.svg";
export { ForwardRef as ReactComponent };